export var TAlertStatus;
(function (TAlertStatus) {
    TAlertStatus["SUCCESS"] = "success";
    TAlertStatus["ERROR"] = "error";
    TAlertStatus["INFO"] = "info";
    TAlertStatus["WARNING"] = "warning";
    TAlertStatus["DEFAULT"] = "default";
})(TAlertStatus || (TAlertStatus = {}));
export var TAlertType;
(function (TAlertType) {
    TAlertType["MIDDLE"] = "MIDDLE";
    TAlertType["TOP"] = "TOP";
    TAlertType["TOPMOST"] = "TOPMOST";
    TAlertType["BOTTOM"] = "BOTTOM";
})(TAlertType || (TAlertType = {}));
